import { useEffect } from "react";
import LoginClient from './Login_client';
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import useAuthStore from "./states/authStore";
// import useLookupStore from "./CRM/states/useLookupStore";
// import useDealStore from "./CRM/states/useDealStore";
// import useAppDataStore from "./states/useAppDataStore";
import entranceAnimation from "./assets/IQVentory Entrance Animation.json";
import Main from './Main'; // main of the whole ERP
// import Admin_Main from './Admin/Main';
// import IT_Main from './IT/Main';
// import CRM_main from './CRM/Main';
// import PM_tool_Main from './PM_tool/Main';
// import PaymentMain from "./Payment/Main";
import { PageTransitionProvider } from "@iq/models";
import ConfirmAppointment from "./pages/confirmAppointment/confirmAppointment";
import PaymentSuccess from "./pages/paymentSucess/paymentSuccess";
import PaymentFailure from "./pages/paymentFailure/PaymentFailture";
import Troubleshoot from "./pages/troubleshoot/Troubleshoot";
import './index.css';

function ProtectedRoute({ children, authenticated, initialized }) {
  // Render nothing until the session check settles (or the grace period expires).
  if (!initialized) {
    return null;
  }

  if (!authenticated) {
    return <Navigate to="/login-client" replace />;
  }

  return children;
}

function App() {
  const navigate = useNavigate();
  const authenticated = useAuthStore((state) => state.authenticated);
  const profileId = useAuthStore((state) => state.profile?.id ?? null);
  const initialized = useAuthStore((state) => state.initialized);
  const bootstrapSession = useAuthStore((state) => state.bootstrapSession);
  const revalidateSession = useAuthStore((state) => state.revalidateSession);
  const permittedApps = useAuthStore((state) => state.permittedApps);

  // const hydrateLookups = useLookupStore((state) => state.hydrateLookups);
  // const resetLookups = useLookupStore((state) => state.resetLookups);
  // const resetDeals = useDealStore((state) => state.resetDeals);
  // const hydrateAppData = useAppDataStore((state) => state.hydrateAppData);
  // const resetAppData = useAppDataStore((state) => state.resetAppData);

  useEffect(() => {
    bootstrapSession();
  }, [bootstrapSession]);

  useEffect(() => {
    if (!initialized) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      revalidateSession();
    }, 60 * 1000);

    return () => window.clearInterval(intervalId);
  }, [initialized, revalidateSession]);

  useEffect(() => {
    if (!initialized) {
      return;
    }

    if (!authenticated) {
      // resetLookups();
      // resetDeals();
      return;
    }

    // Ensure stores refresh when the signed-in profile changes.
    // resetLookups();
    // resetDeals();
    // hydrateLookups();
  }, [initialized, authenticated, profileId]);

  useEffect(() => {
    if (!initialized) {
      return;
    }

    if (!authenticated || !profileId) {
      // resetAppData();
      return;
    }

    // Hydrate shared app lookups (products/orgs) for all routes, not only Main page.
    // resetAppData();
    // hydrateAppData({ id: profileId });
  }, [initialized, authenticated, profileId]);

  // if (!initialized) {
  //   return <div className="App"><div className="Main-display">Loading session...</div></div>;
  // }

  return (
    <div className="App">
      <div className="Main-display">
        {/* <PageTransitionProvider
          animationData={entranceAnimation}
          navigate={navigate}
          enterDurationMs={200}
          animationDurationMs={500}
        > */}
          <Routes>
            <Route path="/login" element={<Navigate to="/login-client" replace />} />
            <Route path="/login-client" element={!initialized ? null : authenticated ? <Navigate to="/" replace /> : <LoginClient />}/>

            <Route path="/confirm/appointment/:hashedAppointmentID" element={<ConfirmAppointment />}/>
            <Route path="/payment-success" element={<PaymentSuccess />}/>
            <Route path="/payment-failure" element={<PaymentFailure />}/>
            <Route path="/" element={<ProtectedRoute authenticated={authenticated} initialized={initialized}><Main enabledAppIds={permittedApps} /></ProtectedRoute>}/>
            <Route path="/troubleshoot" element={<ProtectedRoute authenticated={authenticated} initialized={initialized}><Troubleshoot /></ProtectedRoute>}/>
            <Route path="*" element={!initialized ? null : <Navigate to={authenticated ? "/" : "/login-client"} replace />}/>
            
          </Routes>
        {/* </PageTransitionProvider> */}
      </div>
    </div>
  );
}

export default App;